import { useLocationSearch } from '@rocketlane/rocket-router';
import { useMemo } from 'react';
export const useHeadlessMode = ()=>{
    const search = useLocationSearch();
    const isHeadless = useMemo(()=>{
        if (window.__TAURI_DESKTOP__ || window.__ELECTRON_DESKTOP__) return true;
        const params = new URLSearchParams(search);
        return params.get('snapshot') === 'true';
    }, [
        search
    ]);
    return isHeadless;
};
